import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import { getLeadByID, addNewComment } from '../../redux/reduxActions/leadActions';
import {showToastError} from "../utils";

const AddComment = (props) => {
  const [comment, setComment] = useState();
  const { selectedLead } = props;
  useEffect(() => {
    props.getLeadByID(props.match.params.id);
  }, []);

  function addComment() {
    if (!comment) {
      showToastError('Comment field is required!!!');
      return;
    } else {
      props.addNewComment(selectedLead.id, {text: comment}, props.history.push);
    }
  }

  return (
    <div>
      <div>
        <div className="lead__container" style={{ minHeight: 'auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <h3 style={{ color: '#383838', marginBottom: 0, height: 'min-content' }}>
							Add comment
            </h3>
            <Button
              onClick={() => { addComment(); }}
              variant="primary"
              className="main-button-filled"
            >
							Save
            </Button>
          </div>
          <TextareaAutosize
            onChange={({ target: { value } }) => { setComment(value); }}
            className="lead_input__first-message"
            rows={3}
            placeholder="..."
          />
        </div>
      </div>
    </div>
  );
};
export default connect((store) => ({
  selectedLead: store.leadReducer.selectedLead,
}), { getLeadByID, addNewComment })(AddComment);
